import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import SplitterLayout from 'react-splitter-layout'

import TranscriptsTable from './transcripts-table/TranscriptsTable.jsx'
// import TranscriptsTable from './transcripts-table/TranscriptsTable.1.jsx'
import TranscriptPreviev from './transcript-previev/TranscriptPreviev.jsx'
import { PSTranscriptsLogoIcon } from '../../components/icons'

import './TranscriptViewer.scss'
import 'react-splitter-layout/lib/index.css'

const TranscriptViewer = ({ history }) => (
  <SplitterLayout
    vertical
    customClassName="transcript-viewer_wrapper"
    primaryIndex={1}
    secondaryInitialSize={40}
    secondaryMinSize={40}
  >
    <div className="top-logo">
      <PSTranscriptsLogoIcon />
      <span>Provide Support Live Chat Transcripts</span>
    </div>
    <SplitterLayout
      customClassName="transcript-viewer"
      /* onSecondaryPaneSizeChange={ev => console.log('SplitterLayout', ev)} */
    >
      <TranscriptsTable history={history} />
      <TranscriptPreviev history={history} />
    </SplitterLayout>
  </SplitterLayout>
)

TranscriptViewer.propTypes = {
  history: PropTypes.object.isRequired,
};

export default connect(
  state => ({
  }), dispatch => bindActionCreators({
  }, dispatch),
)(TranscriptViewer);
